var BaseNote = require('../note'),
    fvChannel = require('glRadio').channel('FV');


module.exports = BaseNote.extend({

    isDocument: true,
    pageNumber: 0,  // mimic attribute stored on pgNotes -- set to 0 for sorting reasons

    /*
    * Note: not the url for get -- (these are retrieved in bulk from docInfo and put into collection)
    * This is only used for CRUD operations.
    * The collection here would be 'allNotes', which has ref to document.
    * Add the note sequence for modify operations.
    * */
    url: function() {
        
        var docNotesUrl = fvChannel.request('apiUrl').docNotes( this.collection.document );
        return docNotesUrl + ( this.isNew() ? '' : '/' + this.get('sequence') );
        
    },

    parse: function(response) {

        var resp = BaseNote.prototype.parse.apply( this, arguments );

        // Only do if new ( have not yet been saved ), sequence should suffice for determining if these have been saved.
        // Must do as attribute: don't do this.id ... then we mess we Backbone's guts
        // ( eg if not an attribute save won't automatically add a model to its collection )
        if ( resp.sequence ) {
            resp.id = 'D_' + resp.sequence;
        }

        return resp;

    }

});




/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/models/document/document.js
 ** module id = 277
 ** module chunks = 0
 **/